import { ContentSizeClasses_ContentSize_$ctor_Z207A3CFB } from "../Types/ContentSize.fs.js";
import { Property_CssProperty } from "../Types/MasterTypes.fs.js";

export const Width = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(308));

export const Height = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(144));

export const MinWidth = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(182));

export const MinHeight = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(181));

export const MaxWidth = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(180));

export const MaxHeight = ContentSizeClasses_ContentSize_$ctor_Z207A3CFB(new Property_CssProperty(179));

